import { FlowItem } from './flow-item';

export interface FlowEvent extends FlowItem {
    eventType: FlowEventType;
    action?: FlowEventAction;
}

export interface FlowEventAction {
    type: FlowEventActionType;
    targetSchemaId?: string;
    targetItemId?: string;
    resourceId?: string;
}

export enum FlowEventActionType {
    Jump = 'jump',
    SaveAndJump = 'saveAndJump',
    Finish = 'finish',
    FinishSubProcess = "finishsubprocess",
    GeneratePending = "generatepending"
}

export enum FlowEventType {
    Start = 'start',
    End = 'end'
}
